import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class SalesDistributionUserType {
  public readonly key = 'SalesDistributionUserType';
  public readonly enrollTrackRole = EnrollTrackRole.SalesDistribution;
}
